import repeat from "@lib/util/repeat"
import SkeletonLineItem from "@modules/skeletons/components/skeleton-line-item"
import { ExtendedStoreCart } from "types/global"
import Item from "./item"

type ItemsCartDrawerProps = {
  cart?: ExtendedStoreCart
}

const ItemsCartDrawer = ({ cart }: ItemsCartDrawerProps) => {
  const items = cart?.items
  return (
    <div>
      {items
        ? items
            .sort((a, b) => {
              return (a.created_at ?? "") > (b.created_at ?? "") ? -1 : 1
            })
            .map((item) => {
              return (
                <Item
                  key={item.id}
                  item={item}
                  currencyCode={cart?.currency_code}
                />
              )
            })
        : repeat(5).map((i) => {
            return <SkeletonLineItem key={i} />
          })}
    </div>
  )
}

export default ItemsCartDrawer
